import axios from 'axios';

const emailApiUrl = `${process.env.REACT_APP_API_URL}/Email`;
const defaultFrom =
  process.env.NODE_ENV === 'development' ? 'noreply@codecronie.net' : 'MRPCZ Admin <admin@mrpcz.org.zw>';

/**
 * Send an email using the new notification data model.
 * @param {object} payload - Email payload
 * @param {string|string[]} payload.to
 * @param {string|string[]} [payload.cc]
 * @param {string|string[]} [payload.bcc]
 * @param {string} payload.message - required message/html body
 * @param {string} [payload.subject='MRPCZ Update']
 * @param {string} [payload.title]
 * @param {string} [payload.callToAction]
 * @param {string} [payload.callToActionUrl]
 * @param {string[]} [payload.attachments]
 * @param {string} [payload.userId='memberId']
 * @param {string} [payload.from='MRPCZ Admin <admin@mrpcz.org.zw>']
 * @param {string} adminToken - Bearer token for auth
 */
export const sendEmail = async (payload, adminToken) => {
  const {
    to = [],
    cc = [],
    bcc = [],
    message = '',
    subject = 'MRPCZ Update',
    title = '',
    callToAction = null,
    callToActionUrl = null,
    attachments = [],
    userId = 'memberId',
    from = defaultFrom,
    isHtml = true
  } = payload || {};

  const toArray = Array.isArray(to) ? to : [to].filter(Boolean);
  const ccArray = Array.isArray(cc) ? cc : [cc].filter(Boolean);
  const bccArray = Array.isArray(bcc) ? bcc : [bcc].filter(Boolean);

  try {
    const resp = await axios({
      method: 'post',
      url: emailApiUrl,
      data: {
        userId,
        from,
        to: toArray,
        cc: ccArray,
        bcc: bccArray,
        subject,
        message,
        isHtml,
        title,
        callToAction,
        callToActionUrl,
        attachments
      },
      headers: { Authorization: `Bearer ${adminToken}` }
    });
    console.log({ resp });
  } catch (error) {
    console.error('There was an error!', error);
  }
};
